import StoredLayout from '../../layouts/StoredLayout'
import VectorMaps from './VectorMaps'
export default StoredLayout(VectorMaps)



// WEBPACK FOOTER //
// ./src/maps/vector-maps/index.js